import { shareChat } from '@/pages/api/scribeAPIV2';
import { logger } from '@/utils/logger/logger';
import { useMutation } from '@tanstack/react-query';

export interface UseShareChatResult {
  shareToken: string;
  shareUrl: string;
  previewQuestion: string;
  previewResponse: string;
  chatTitle: string;
}

/**
 * Mutation hook for sharing an Evidence chat.
 *
 * Creates a shareable link for the chat. The link never expires and
 * recipients can view and continue the conversation in their own copy.
 */
export function useMutateShareChat() {
  return useMutation<UseShareChatResult, Error, string>({
    mutationFn: async (chatId: string) => {
      const { data } = await shareChat(chatId);

      return {
        shareToken: data.share_token,
        shareUrl: data.share_url,
        previewQuestion: data.preview_question,
        previewResponse: data.preview_response,
        chatTitle: data.chat_title,
      };
    },
    onError: (error) => {
      logger.error('Failed to share chat', { error });
    },
  });
}
